module.exports = __webpack_public_path__ + "static/media/bd-small.35d8d85b.jpg";